import {getGoal, getRestaurantGoal} from "@/api/information";

let inflightPromise = null;
let inflightKey = null;

// WTK-564: goal 永远是对象 { 类别: 数字 | null }。null / 缺 key = 未设置；接口没给 goal 时按 {} 处理。
function toGoalMap(value) {
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
}

function getEntityKey(rootState) {
    const isHotel = rootState.hotel.isHotel;
    const currentHotelId = rootState.hotel.currentHotelId;
    const selectedRestaurantId = rootState.restaurant.selectedRestaurantId;
    if (isHotel) {
        return currentHotelId ? `hotel:${currentHotelId}` : null;
    }
    return selectedRestaurantId ? `restaurant:${selectedRestaurantId}` : null;
}

export default {
    namespaced: true,
    state: {
        goal: {},
        loadedKey: null,
    },
    mutations: {
        SET_GOAL(state, value) {
            state.goal = toGoalMap(value);
        },
        SET_LOADED_KEY(state, key) {
            state.loadedKey = key;
        },
        RESET_GOAL_CACHE(state) {
            state.goal = {};
            state.loadedKey = null;
        },
    },
    actions: {
        update_goal({state, rootState, commit}, {force = false} = {}) {
            const entityKey = getEntityKey(rootState);
            if (!entityKey) {
                return Promise.resolve(null);
            }

            const isCached =
                !force
                && state.loadedKey === entityKey
                && state.goal
                && typeof state.goal === "object";

            if (isCached) {
                return Promise.resolve({goal: state.goal});
            }

            if (!force && inflightPromise && inflightKey === entityKey) {
                return inflightPromise;
            }

            const isHotel = rootState.hotel.isHotel;
            const currentHotelId = rootState.hotel.currentHotelId;
            const selectedRestaurantId = rootState.restaurant.selectedRestaurantId;

            inflightKey = entityKey;
            inflightPromise = (isHotel
                ? getGoal({hotelId: currentHotelId})
                : getRestaurantGoal({restaurantId: selectedRestaurantId}))
                .then((res) => {
                    commit("SET_GOAL", res && res.goal);
                    commit("SET_LOADED_KEY", entityKey);
                    return res;
                })
                .finally(() => {
                    inflightPromise = null;
                    inflightKey = null;
                });

            return inflightPromise;
        },
    },
};
